import { Component, Input, OnInit } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailPageContentRendererInterface,
  WagtailRichtextRendererInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-richtext',
    templateUrl: './richtext.component.html',
    styleUrls: ['./richtext.component.scss'],
    standalone: false
})
export class WagtailRichtextComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailPageContentRendererInterface>
  content?: WagtailRichtextRendererInterface

  ngOnInit(): void {
    if (this.definition) {
      this.content = ({ richtext: this.definition.value } as WagtailRichtextRendererInterface)
    }
  }
}
